/* eslint-disable */
import React, { useEffect, Fragment, useState, useCallback } from 'react'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'

import BackgroundHero from '../../static/images/hero-banner/halo-auto-background.svg'
import BackgroundMobile from '../../static/images/hero-banner/halo-auto-mobile.svg'
import ImageHero from '../../static/images/hero-banner/halo-auto-image.svg'
import HeroBanner from '../../components/hero-banner'
import CardDownload from '../../components/card-download'
import Testimonial from '../../components/testimonial'
import CardJoin from '../../components/card-join'
import Why from './why'
import Vendor from './vendor'
import ServiceList from './service-list'
import Advantage from './advantage'
import BackgroundImage from '../../static/images/card-download/halo-auto.svg'
import BackgroundJoin from '../../static/images/card-join/background-auto.svg'
import ava from '../../static/icons/card-icon/ic-icon-fix.svg'
import IllustrationJoin from '../../static/images/card-join/illustration-auto.svg'
import haloAutoIllust from '../../static/images/card-join/halo-auto-illus.svg'
import {
  TitleHeroBanner,
  TitleSubHeroBanner,
  TitleTag,
  TitleHeroBannerForSeo
} from '../../components/text'
import image3 from '../../static/icons/testimonial/image-3.png'
import image1 from '../../static/icons/testimonial/image-1.png'
import image5 from '../../static/icons/testimonial/image-5.png'
import ImageDownloadLink from '../../components/image-download/index'
import FixedServices from '../../components/services-fixed/index'
import FixedServicesResponsive from '../../components/service-fixed-responsive/index'
import { StyleDownload, StyleCardJoin } from './index.styles'

const HaloAuto = () => {
  const { t } = useTranslation()
  const [isActiveStick, setActiveStick] = useState(true)

  const hideStick = useCallback(() => {
    setActiveStick(false)
  }, [])

  const [isHeaderShow, setIsHeaderShow] = useState(false)
  const [nowPosition, setCurrentPosition] = useState(0)

  const trackScrolling = useCallback(() => {
    const currentScrollPos = window.pageYOffset
    if (currentScrollPos > nowPosition + 100) {
      setActiveStick(false)
    } else if (currentScrollPos < nowPosition + 200) {
      setActiveStick(true)
    }
    setCurrentPosition(currentScrollPos)
  }, [nowPosition])

  useEffect(() => {
    document.addEventListener('scroll', trackScrolling)
    return () => {
      document.removeEventListener('scroll', trackScrolling)
    }
  }, [trackScrolling])

  return (
    <Fragment>
      <Helmet>
        <title>Jasa Salon Mobil Panggilan | halojasa.com</title>
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="Menghadirkan jasa cuci mobil dan motor serta melayani salon mobil panggilan sebagai solusi layanan kebersihan kendaraan dengan cleaner profesional dan berintegrasi"
        />
        <meta
          property="og:title"
          content="Salon Mobil Dan Cuci Mobil, Motor Murah | halojasa.com"
        />
        <meta property="og:site_name" content="Halo Jasa" />
        <meta
          property="og:description"
          content="Menghadirkan jasa cuci mobil dan motor serta melayani salon mobil panggilan sebagai solusi layanan kebersihan kendaraan dengan cleaner profesional dan berintegrasi"
        />
        <meta
          property="og:url"
          content="https://halojasa.com/salon-mobil-pangilan/"
        />
        <meta
          property="og:image"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/haloauto-ls.png"
        />
        <meta
          property="og:image:secure_url"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/haloauto-ls.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image"
          itemProp="image"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/haloauto-sq.png"
        />
        <meta
          property="og:image:secure_url"
          itemProp="image"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/haloauto-sq.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="300" />
        <meta property="og:image:height" content="268" />
        <meta property="og:type" content="website" />
        <meta property="fb:app_id" content="951866408583742" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@pthalojasa" />
        <meta
          name="twitter:title"
          content="Salon Mobil Dan Cuci Mobil, Motor Murah | halojasa.com"
        />
        <meta
          name="twitter:description"
          content="Menghadirkan jasa cuci mobil dan motor serta melayani salon mobil panggilan sebagai solusi layanan kebersihan kendaraan dengan cleaner profesional dan berintegrasi"
        />
        <meta
          name="twitter:image:src"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/haloauto-ls.png"
        />
        <meta
          name="keyword"
          content="jasa salon mobil panggilan, jasa cuci mobil panggilan"
        />
        <meta
          name="p:domain_verify"
          content="4e6fcb4deba1a02d84225fad69babc0b"
        />
        <link
          rel="canonical"
          href="https://halojasa.com/salon-mobil-pangilan/"
        />
      </Helmet>
      <HeroBanner
        title={
          <div>
            <TitleHeroBannerForSeo align="left">
              {t('pageSalonMobilPangilan.part51')}
            </TitleHeroBannerForSeo>
            <TitleHeroBanner className="hero-title uppercase" align="left">
              <span className="auto-title-color">Halo Auto -</span> Daily Urban
            </TitleHeroBanner>
            <TitleHeroBanner className="hero-title uppercase" align="left">
              Lifestyle Service
            </TitleHeroBanner>
          </div>
        }
        picture={{
          background: BackgroundHero,
          image: ImageHero,
          mobile: BackgroundMobile
        }}
        subTitleHeroBanner={
          <div>
            <TitleSubHeroBanner
              align="left"
              className="title-sub-banner auto-color"
            >
              {t('pageSalonMobilPangilan.part1')}
            </TitleSubHeroBanner>
          </div>
        }
        paragraph={
          <div>
            <p className="hero-desc">{t('pageSalonMobilPangilan.part3')}</p>
            <h2 className="hero-seo">{t('pageSalonMobilPangilan.part52')}</h2>
            <ImageDownloadLink />
          </div>
        }
        tag={<TitleTag>#{t('pageSalonMobilPangilan.part2')}</TitleTag>}
        breadCrumb={[
          {
            name: 'Beranda',
            link: '/'
          },
          {
            name: 'Layanan Kami',
            link: '/'
          },
          {
            name: 'Halo Auto',
            link: false
          }
        ]}
      ></HeroBanner>

      <Why></Why>

      <StyleDownload>
        <CardDownload
          contentImage={haloAutoIllust}
          boxShadow="0 10px 10px 0 rgba(143, 116, 255, 0.3)"
          border="solid 1px #e3dbff"
          backgroundImage={BackgroundImage}
          title={t('pageSalonMobilPangilan.part12')}
          tag={`# ${t('pageSalonMobilPangilan.part2')}`}
          desc={t('pageSalonMobilPangilan.part13')}
        ></CardDownload>
      </StyleDownload>

      <ServiceList></ServiceList>

      <Vendor></Vendor>

      <Testimonial
        data={[
          {
            name: 'Bpk Gedion',
            desc:
              '"puas  dan bisa diandalkan" sekarang nggakperlu report report lagi karena ada halo jasa, tx banget.',
            job: 'Bisnis Owner',
            avatarImage: image1,
            key: 1
          },
          {
            name: 'Ibu rumah tangga',
            desc:
              '"petugasnya sangat ramah dan berhati-hati saat mengerjakan. Membuat saya lebih aman dan nyaman ketika mobil harus dibersihkan. Bagi saya sangat rekomended sekali"',
            job: 'Ibu rumah tangga',
            avatarImage: image3,
            key: 2
          },
          {
            name: 'Mba Yulina',
            desc:
              '"Bersyukur sekali dengan layanan halo jasa, sekarang nggakperlu capek capek ngantri lagi,apalagi kalo musim hujan"',
            job: 'Mahasiwa',
            avatarImage: image5,
            key: 3
          },
          {
            name: 'Bpk Gedion',
            desc:
              '"puas  dan bisa diandalkan" sekarang nggakperlu report report lagi karena ada halo jasa, tx banget.',
            job: 'Bisnis Owner',
            avatarImage: image1,
            key: 4
          }
        ]}
      ></Testimonial>

      <Advantage></Advantage>
      {window.innerWidth > 1023 ? (
        <FixedServices></FixedServices>
      ) : (
        <FixedServicesResponsive></FixedServicesResponsive>
      )}

      <StyleCardJoin>
        <CardJoin
          marginTop="100px"
          boxShadow="0 10px 10px 0 rgba(143, 116, 255, 0.05)"
          border="solid 1px #e3dbff"
          backgroundImage={BackgroundJoin}
          image={IllustrationJoin}
          ava={ava}
          buttonColor="linear-gradient(to left, #b7caf5, #888cdd 50%, #8067de)"
          title="Halo Fix – AC Kembali Sedingin Semula"
          tag="#solusimaudingin"
          desc={t('pageSalonMobilPangilan.part49')}
        ></CardJoin>
      </StyleCardJoin>
    </Fragment>
  )
}

export default HaloAuto
